import React, { Component } from "react";
import PropTypes from "prop-types";

import LineSeries from "./LineSeries";

const normalizeStroke = (stroke, fallback) => ({
  color: stroke?.color || fallback.color,
  dash: stroke?.dash || fallback.dash,
  width: stroke?.width ?? fallback.width,
  opacity: stroke?.opacity ?? fallback.opacity,
});

const FALLBACK_JAW = { color: "#0000FF", dash: "Solid", width: 1, opacity: 1 };
const FALLBACK_TEETH = {
  color: "#FF0000",
  dash: "Solid",
  width: 1,
  opacity: 1,
};
const FALLBACK_LIPS = { color: "#00DD00", dash: "Solid", width: 1, opacity: 1 };

class AlligatorSeries extends Component {
  constructor(props) {
    super(props);
    this.yAccessorJaw = this.yAccessorJaw.bind(this);
    this.yAccessorTeeth = this.yAccessorTeeth.bind(this);
    this.yAccessorLips = this.yAccessorLips.bind(this);
  }

  static yExtents(datum, index, allData, indicator) {
    const dataArr = Array.isArray(allData)
      ? allData
      : Array.isArray(datum)
        ? datum
        : [datum];

    if (!indicator || !indicator.renderKey) {
      return undefined;
    }

    let min = Number.POSITIVE_INFINITY;
    let max = Number.NEGATIVE_INFINITY;

    const updateExtents = (value) => {
      if (!Number.isFinite(value)) return;
      if (value < min) min = value;
      if (value > max) max = value;
    };

    dataArr.forEach((item) => {
      const node = item && item[indicator.renderKey];
      if (!node || typeof node !== "object") return;

      updateExtents(node.jaw);
      updateExtents(node.teeth);
      updateExtents(node.lips);
    });

    // If no valid data, return undefined to use price extents
    if (!Number.isFinite(min) || !Number.isFinite(max)) {
      return undefined;
    }

    // Add 2% padding
    const range = max - min;
    const padding = range * 0.02;

    return [min - padding, max + padding];
  }

  valueFromDatum(d, key) {
    if (!d) return undefined;
    const { yAccessor } = this.props;
    const node = yAccessor ? yAccessor(d) : undefined;
    const raw = node ? node[key] : undefined;
    return Number.isFinite(raw) ? raw : undefined;
  }

  yAccessorJaw(d) {
    return this.valueFromDatum(d, "jaw");
  }

  yAccessorTeeth(d) {
    return this.valueFromDatum(d, "teeth");
  }

  yAccessorLips(d) {
    return this.valueFromDatum(d, "lips");
  }

  render() {
    const { className, onDoubleClick, onContextMenu, clip } = this.props;
    const { strokeJaw, strokeTeeth, strokeLips } = this.props;

    const jawStroke = normalizeStroke(strokeJaw, FALLBACK_JAW);
    const teethStroke = normalizeStroke(strokeTeeth, FALLBACK_TEETH);
    const lipsStroke = normalizeStroke(strokeLips, FALLBACK_LIPS);

    return (
      <g className={className}>
        <LineSeries
          yAccessor={this.yAccessorJaw}
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
          stroke={jawStroke}
          clip={clip}
        />
        <LineSeries
          yAccessor={this.yAccessorTeeth}
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
          stroke={teethStroke}
          clip={clip}
        />
        <LineSeries
          yAccessor={this.yAccessorLips}
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
          stroke={lipsStroke}
          clip={clip}
        />
      </g>
    );
  }
}

AlligatorSeries.propTypes = {
  className: PropTypes.string,
  yAccessor: PropTypes.func.isRequired,
  clip: PropTypes.bool.isRequired,
  strokeJaw: PropTypes.object.isRequired,
  strokeTeeth: PropTypes.object.isRequired,
  strokeLips: PropTypes.object.isRequired,
  onDoubleClick: PropTypes.func,
  onContextMenu: PropTypes.func,
};

AlligatorSeries.defaultProps = {
  className: "react-stockcharts-alligator-series",
  clip: true,
};

export default AlligatorSeries;
